import { V1_SUBMIT_SEARCH_QUERY } from '../../actions/search/v1submitSearchQuery'
import { V1_REQUEST_SEARCH_RESULTS } from '../../actions/search/v1requestSearchResults'
import { V1_RECEIVE_SEARCH_RESULTS } from '../../actions/search/v1receiveSearchResults'
import { V1_RESET_SEARCH_RESULTS } from '../../actions/search/v1resetSearchResults'

const initialState = {
  isFetching: false,
  results: [],
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case V1_SUBMIT_SEARCH_QUERY:
      return {
        ...state,
        isFetching: true,
        results: [], // clear the previous results
      }
    case V1_REQUEST_SEARCH_RESULTS:
      return {
        ...state,
        isFetching: true,
      }
    case V1_RECEIVE_SEARCH_RESULTS:
      return {
        ...state,
        isFetching: false,
        results: action.data,
      }
    case V1_RESET_SEARCH_RESULTS:
      return initialState
    default:
      return state
  }
}
